export enum ImportRequestStatus {
  FailedValidation = 1,
  Received,
  Processed,
  NewRequestReceived,
}
